<template>
    <div>
        <el-dialog class="doc_send_dialog" title="发送文书" width="60%" :close-on-click-modal=false :visible.sync="dialogVisible" :append-to-body="true" :before-close="recordClose" center>
            <div class="doc_send_wrap">
                <div v-for="(item, index) in typeOptions" :key="index">
                    <div class="item_title">
                        <el-checkbox v-model="item.status">{{item.docName}}</el-checkbox>
                        <div class="item_desc" v-if="item.status">*只能上传pdf/doc/docx文件，{{maxFileTip}}</div>
                    </div>
                    <div class="item_upload" v-if="item.status">
                        <div v-if="item.docInfo && item.docInfo.length>0" class="item-tags">
                            <el-tag  v-for="(doc, dIndex) in item.docInfo" closable @close="handleTagClose(item, dIndex)" style="margin-right: 20px">
                                {{doc.name}}
                            </el-tag>
                        </div>
                        <div v-else></div>
                        <el-upload class="upload-doc" :ref="item.docType" :action="fileUploads.actionUrl" :accept="fileUploads.acceptType" :headers="fileUploads.flk" :on-change="function (file, fileList){return handleChange(file, fileList, item)}" :show-file-list="false" :auto-upload="false">
                            <el-button size="small" icon="el-icon-upload2">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="recordClose(null)">取 消</el-button>
                <el-button type="primary" :loading="BtnLoading" @click="handleSendBook(0)" style="width: 160px">发送并预览回证</el-button>
            </div>
        </el-dialog>
        <el-dialog class="doc_send_dialog"  title="发送文书" :close-on-click-modal=false :visible.sync="showUploadTSDoc" :append-to-body="true" center>
            <div class="doc_send_wrap">
                <iframe class="doc_make_frame"  :src="filePreview.clerkRecordPdfUrl" :title="filePreview.fileName"></iframe>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="showUploadTSDoc = false">取 消</el-button>
                <el-button type="primary" :loading="BtnLoading" @click="handleSendBook(1)">发送</el-button>
                <el-button type="primary" @click="downLoad()">下载word版本</el-button>
                <el-upload class="upload-doc" ref="upload"
                           :action="fileUploads.actionUrl"
                           :accept="fileUploads.acceptType"
                           :headers="fileUploads.flk"
                           :http-request="function(file) {}"
                           :on-change="handleChange2"
                           :show-file-list="false"
                           :file-list="[]"
                           :limit="fileUploads.limit"
                           :multiple="fileUploads.multiple"
                           :auto-upload="false">
                    <el-button type="primary">上传修正版</el-button>
                </el-upload>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    sendDocBook,
    getMediationRoomUserInfoList,
    queryDocTempList,
    createClerkRecord,
    sendClerkRecordGzzc
} from "@/api/casespace_doclist.js";
import {uploadRevision} from "../../../api/casespace";


import {
  getFileExtendName,
  getStore, toastSuc, toastWarning
} from '@/utils/utils.js'
import config from '@/config/config.js'
import {sendPreview, sendOnlineDoc} from "../../../api/casespace";
import {maxFileLength, maxFileWarning, maxFileTip} from "../../../utils/utils";
export default {
    props: ['wsLink', 'currentRoomId'],
    data() {
        return {
            filePreview: {
            },
            dialogVisible: false,
            maxFileTip: maxFileTip,
            typeOptions: [],
            //模板下载地址
            templateUrl: '',
            fileUploads: {
                actionUrl: `${config.baseURL}/gzzc/docBook/upload`,
                acceptType: '.pdf,.doc,.docx',
                flk: {
                    JWTToken: getStore('flk'),
                    appName: config.appName,
                    cType: 'PC'
                },
                fileData: {
                    isView: 'NOVIEW'
                },
                fileList: "",
                fileJson: []
            },
            buttonStatus: false,
            BtnLoading: false,
            curCaseId: null,
            curMeetingId: null,
            curRoomUserList: {},
            curRoomUserIdList: [],
            docObj: {},
            fileUrl: '',
            clerkRecordDownloadUrl:'',
            showUploadTSDoc: false,
        }
    },
    created() {
        this.curCaseId = this.$route.query.caseid
        this.curMeetingId = this.$route.query.meetingid
    },
    methods: {
        //获取笔录模板
        getDocTempList() {
            let param = {
                "onlineStatus": 1,
                "pageIndex": 1,
                "bizCode": 'gzzc_sd',
                "pageSize": 200
            }
            queryDocTempList(param).then(res => {
                if (res.data.code === 1000) {
                    if (res.data.data.list.length > 0) {
                        this.typeOptions = []
                        res.data.data.list.forEach(item => {
                            item.status = false
                            item.docInfo = []
                            this.typeOptions.push(item)
                        })
                        this.$forceUpdate()
                    }
                }
            })
        },
        openDocDialog() {
            let userData = {}
            this.getDocTempList()
            getMediationRoomUserInfoList({
                "id": this.curCaseId
            }).then(res => {
                if (res.data.code === 1000) {
                    res.data.data.forEach(element => {
                        userData[element.userId] = element
                    })
                    this.curRoomUserList = userData
                    this.curRoomUserIdList = res.data.data.map(item => {
                        return {
                            id: item.userId,
                            name: item.userName
                        }
                    })
                }
                this.dialogVisible = true
            }, err => {
                this.dialogVisible = true
            })
        },
        handleTagClose(item, index) {
            if (item.docType == 'GZZC_SD_OTHER_MATERIAL') {
                item.docInfo.splice(index, 1)
            } else {
                item.docInfo = []
            }
        },
        recordClose(done) {
            this.dialogVisible = false
        },
        handleChange(file, fileList, item) {
            if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            let tempRet = /\.[^.]+$/.exec(file.name)
            let isAcceptType = true
            if (tempRet) {
                if (!~this.fileUploads.acceptType.indexOf(tempRet[0])) {
                    isAcceptType = false
                }
            }
            if (!isAcceptType) {
                this.$message({
                    type: 'warning',
                    message: '文件只支持' + this.fileUploads.acceptType + '等格式'
                });
                fileList.pop()
                return
            }
            if (tempRet.index > 20) {
                this.$message({
                    type: 'warning',
                    message: '文件名不超过20个字符长度'
                })
                return false
            }

            if (item.docType == 'GZZC_SD_OTHER_MATERIAL') {
                item.docInfo = fileList
            } else {
                item.docInfo = [file]
            }
        },
        handleChange2(file, fileList, item) {
            if (file.size > maxFileLength) {
                this.$message({
                    type: 'warning',
                    message: maxFileWarning
                });
                return false
            }
            let tempRet = /\.[^.]+$/.exec(file.name)
            let isAcceptType = true
            if (tempRet) {
                if (!~this.fileUploads.acceptType.indexOf(tempRet[0])) {
                    isAcceptType = false
                }
            }
            if (!isAcceptType) {
                this.$message({
                    type: 'warning',
                    message: '文件只支持' + this.fileUploads.acceptType + '等格式'
                });
                fileList.pop()
                return
            }
            if (tempRet.index > 20) {
                this.$message({
                    type: 'warning',
                    message: '文件名不超过20个字符长度'
                })
                return false
            }

            let self = this
            self.$refs.upload.submit();
            let params = new FormData()
            params.append('docId', self.filePreview.documentId)
            params.append('uploadFile', file.raw)
            self.BtnLoading = true

            uploadRevision(params).then(res => {
                if (res.data.code === 1000) {
                    this.filePreview.fileId = res.data.data.fileId
                    this.filePreview.fileName = res.data.data.fileName
                    this.filePreview.clerkRecordDownloadUrl = res.data.data.clerkRecordDownloadUrl
                    this.filePreview.clerkRecordPdfUrl = res.data.data.clerkRecordPdfUrl
                    self.$refs.upload.clearFiles();
                } else {
                    self.$message({
                        message: res.data.message,
                        type: 'error'
                    })
                }
                self.BtnLoading = false
            }, err => {
                self.BtnLoading = false
            })

        },
        downLoad() {
            window.open(this.filePreview.clerkRecordDownloadUrl)
        },
        handleSendBook(dtype) {
            let self = this
            let selectArr = this.typeOptions.filter(function (item) {return item.status == true})
            if (!selectArr || selectArr.length == 0) {
                this.$message.error('请选择发送文书的类型并上传文书')
                return
            }
            for (let i=0; i<selectArr.length; i++){
                let item = selectArr[i]
                if (!item.docInfo || item.docInfo.length == 0) {
                    this.$message.error(`请上传${item.docName}`)
                    return
                }
            }

            if (dtype == 0) {
                // 校验
                let previewParam = []
                selectArr.forEach(item => {
                    previewParam.push({
                        meetingId: self.curMeetingId,
                        docName: item.docName
                    })
                })
                this.BtnLoading = true
                sendPreview(previewParam).then(res => {
                    this.BtnLoading = false
                    if (res.data.code === 1000) {
                        this.dialogVisible = false
                        this.showUploadTSDoc = true
                        this.filePreview = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(error => {
                    this.BtnLoading = false
                })
            } else {
                let param = new FormData(), index = 0
                param.append(`meetingId`, self.curMeetingId)
                param.append('docId', this.filePreview.documentId)
                selectArr.forEach(item => {
                    item.docInfo.forEach(docInfo => {
                        if (docInfo.name) {
                            param.append(`files[${index}].fileName`, docInfo.name)
                            param.append(`files[${index}].uploadFile`, docInfo.raw)
                            param.append(`files[${index}].docType`, item.docType)
                            index ++
                        }
                    })
                })
                // item.docInfo.files = file.file

                this.BtnLoading = true
                sendOnlineDoc(param).then(res => {
                    this.BtnLoading = false
                    if (res.data.code === 1000) {
                        this.dialogVisible = false
                        this.showUploadTSDoc = false
                        this.$message.success('发送成功')
                        self.$emit('loadPage')
                    } else {
                        this.$message.error(res.data.message)
                    }
                }).catch(error => {
                    this.BtnLoading = false
                })
            }
        },
    },
}
</script>

<style lang="scss">
.doc_send_dialog {
    .el-dialog__body {
        padding: 25px 25px;
    }

    .el-checkbox {
        flex-shrink: 0;
        font-size: 16px;
        margin-right: 16px;
    }
    .el-checkbox__label {
        font-size: 16px;
        color: #666666;
    }
    .item_title {
        display: flex;
        justify-content: space-between;
        flex-wrap: nowrap;
        line-height: 60px;
        color: #999999;
        .item_desc {
            font-size: 13px;
            color: #999;
            flex-shrink: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .item_upload {
        display: flex;
        text-align: right;
        justify-content: space-between;
        padding: 20px 16px;
        background-color: #f6f7f9;
        border-radius: 4px;
        .item-tags {
            display: flex;
            flex-wrap: wrap;
            width: calc(100% - 100px);
        }
        .upload-doc {
            width: 100px;
        }
    }
    .doc_send_wrap {
        margin: 0 25px;

        .doc_template {
            margin-left: 15px;
            text-decoration: underline;
            color: #428BC6;
            cursor: pointer;
        }

        iframe {
            width: 650px;
            height: 600px;
            border: 0;
            border: 1px solid #efefef;
        }

        .upload-doc {
            flex-shrink: 0;
        }

        .doc_type {
            width: 100%;
        }
    }

    .dialog-footer {
        padding-bottom: 20px;

        .el-button {
            width: 120px;
            height: 40px;
        }
        .upload-doc {
            display: inline-block;
        }
    }

    .el-button+.el-button {
        margin-left: 40px;
    }

    .el-dialog {
        margin-top: 5vh !important;
        width: 754px !important;
    }
}
</style>
